import axios from 'axios'
import qs from 'qs'
import { Message, MessageBox } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

// 创建AI后端专用的axios实例
const aiService = axios.create({
  baseURL: process.env.VUE_APP_AI_API, // AI后端地址
  timeout: 500000,
  paramsSerializer(params) {
    return qs.stringify(params, {
      arrayFormat: 'repeat'
    })
  }
})

// 请求拦截器
aiService.interceptors.request.use(
  config => {
    if (Object.prototype.toString.call(config.data) == "[object Object]" && config.isFormData) {
      var list = [];
      let obj = config.data
      for (var key in obj) {
        if (obj[key] !== undefined && obj[key] !== null) {
          list.push(`${key}=${encodeURIComponent(obj[key])}`)
        }
      }
      let str = list.join("&")
      config.data = str
    }

    if (getToken()) {
      // 携带token，与管理系统保持一致的格式
      config.headers['Token'] = 'DU ' + getToken()
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
aiService.interceptors.response.use(
  response => {
    // 如果是blob响应或跳过拦截器，直接返回
    if (response.config.skipInterceptor || response.config.responseType === 'blob') {
      return response
    }

    const data = response.data
    if (response.status >= 200 && response.status < 300) {
      // 处理认证错误
      if (data.errorCode === 'UNAUTHORIZED_LOGIN' ||
          (data.success === false && data.errorCode && data.errorCode.includes('UNAUTHORIZED'))) {
        const errorMsg = data.errorMessage || data.message || '用户会话数据异常，请重新登录！'
        MessageBox.alert(errorMsg, '错误', {
          confirmButtonText: '确定',
          type: 'error'
        }).then(() => {
          removeToken()
          resetRouter()
          location.reload()
        })
        return Promise.reject('error')
      }

      // 处理业务错误
      if (data.code === '-1' || data.success === false) {
        Message({ message: data.message || '操作失败', type: 'error' })
        return Promise.reject('error')
      }

      return data
    } else {
      return Promise.reject(new Error(data))
    }
  },
  error => {
    console.error('AI API Request error:', error)

    let message = error.message || '网络请求失败'

    if (error.response) {
      const { status, data } = error.response

      if (data && data.message) {
        message = data.message
      } else if (status === 404) {
        message = '请求的资源不存在'
      } else if (status === 500) {
        message = '服务器内部错误'
      } else if (status === 403) {
        message = '没有权限访问'
      } else {
        message = `请求失败 (${status})`
      }
    } else if (error.request) {
      message = '网络连接失败，请检查网络'
    }

    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default aiService
